module.exports = __webpack_public_path__ + "static/media/lenciso2.99dce95c.jpg";